module.exports = __webpack_public_path__ + "static/AR3-5bdcc623ada3368f8f1576efe5d0c086.png";